// const $ = require('jquery');
// $.noConflict();
// $.DataTable = require('datatables.net');
import WithSystem from './../service/WithSystem';
class Tbl extends React.Component {
  constructor(props) {
    super(props);    
    this.state = {
      isFetching: false,
      headerItems:false,
      enquiry_json:false,
      sort:'',
      renderData:false,
      tableHeadData:false,
      filters : ''     
    }
    this.tablerender = null;
    this.renderData = [];
    this.renderTable = true;
    window.deleteEnquiry = this.deleteEnquiry;
  }
  componentDidMount() {
    this.TableDataAsJson();
  }
  TableDataAsJson   = async () => {
    // if(this.state.renderData) {
    //   return this.state.renderData;
    // }
    // let apiCall    = `${admin_url}report/enquiry_labels`;
    // let formData   = new FormData();
    // const fetchOptions = {
    //   method: "POST",
    //   body: formData
    // };
    // const response = await fetch(apiCall, fetchOptions);
    // var apiResponse  = await response.json();
    // console.log(apiResponse);
    var renderData   = __labelSettings;//apiResponse.label_settings;
    // return false;
    // this.renderData  = renderData;
    // this.setState({isFetching: true});
    // console.log(renderData);
    this.setState({renderData: renderData});
  }

  renderTableHeader(){
    // return (<tr><td>dfsdf</td></tr>);
   if(!this.state.headerItems) {

      if(this.state.renderData) {
        
        let renderData =[{id: "createdAt", label: "Enquiry Date"},{id: "product_id", label: "Product Name"}];
        renderData = renderData.concat(this.state.renderData);
        // console.log(renderData, 'renderData');
        // this.tableHeadData = renderData;
        let deleteRenderData =[{id: "delete", label: "Delete"}];
        renderData = renderData.concat(deleteRenderData);    
        const headerItems = renderData.map((fields) =>
                                            (fields.id == 'product_id' || fields.id == 'delete') ?<th key={fields.id} className="no-sort" style={{"width": "20%"}}>{fields.label}</th> :<th key={fields.id} style={{"width": "20%"}}>{fields.label}</th>
                                          );
                                          // console.log(headerItems, 'headerItems');
                                          // return (<tr>{headerItems}</tr>);
        this.setState({'headerItems':headerItems, 'tableHeadData':renderData}, () => {
                        this.overallreportrender()
                      }); 
        return (<tr key="headers">{headerItems}</tr>);           
      }
      // this.TableDataAsJson();
    }

    if(this.state.renderData) {
      return ( <tr>{this.state.headerItems}</tr>);
    }
    
    // this.TableDataAsJson();
 }

  changeDateFormat = (dat) => {
    var yourdate = dat.split("/").reverse();
    var tmp = yourdate[2];
    yourdate[2] = yourdate[1];
    yourdate[1] = tmp;
    yourdate = yourdate.join("-");
    return yourdate;
  }
  
  deleteEnquiry = (id,thisval) => {    
    var messageObject = {
      'body': `Are you sure to delete the enquiry ?
              `,
      'button_yes': 'Delete',
      'button_no': 'Cancel',
      'continue_params':{'id':id,'thisval':thisval},
   }; console.log("thisval1",thisval)
   window.callback_warning_modal(messageObject,this.deleteEnquiryConfirmed);
  }

  deleteEnquiryConfirmed= async(param) => {
    var remove_row = param.data.thisval;
    $.ajax({
        url: __apiUrl+'delete',
        type: "DELETE",
        headers:{'x-access-token':__apiToken},
        data: {"_id":param.data.id},
        success: function (data) {
          $("#common_message_advanced .close").click()
            if (data.success == true) {      
              $("#bc-datatable").dataTable().api().row(remove_row).remove().draw();          
              window.toastr["success"]('', "Enquiry Deleted Successfully.");
            } else {
              window.toastr["error"]('', "Something wrong, please try again later.");
            }

        }
    }); 
  }

  overallreportrender = () => {
    $('#bc-datatable').DataTable().destroy();
    var token = __apiToken;
    var apiUrl = __apiUrl;
    var product_list = this.props.queryFilter.products;
    var tableHeadData = this.state.tableHeadData;
    var sort = this.sort;
    var startdate = '';
    var enddate = '';
    var product_type = (this.props.queryFilter.product_type != false)?this.props.queryFilter.product_type:'';
    var product_id = '';
    if(this.props.queryFilter.startdate != false && this.props.queryFilter.startdate != '') {
      startdate = this.changeDateFormat(this.props.queryFilter.startdate);
    }
    if(this.props.queryFilter.enddate != false && this.props.queryFilter.enddate != '') {
      enddate = this.changeDateFormat(this.props.queryFilter.enddate);
    }
    if(this.props.queryFilter.product_id != false && this.props.queryFilter.product_id != '') {
      var product = this.props.queryFilter.product_id.split('_');
      product_type = product[0];
      product_id = product[1];
    }
    if(!this.state.enquiry_json || __filter_applied === true)
    {
      __filter_applied          = false;
      
    this.tablerender = $(this.refs.main).DataTable({
      "lengthMenu": [50],
      "lengthChange": false,
      "ordering": true,
      "bFilter": false,
      "stateSave": true,
      "bStateSave": true,
      "ordering": true,
      "columnDefs": [
        { 
          "className": "center-align",
        "defaultContent": "-",
        "targets": "_all", },
      ],  
      scrollY:        "100vh",
      scrollX:        true,
      scrollCollapse: true,
      paging:         true,
      // fixedColumns:   {
      //     leftColumns: 0,
      //     rightColumns: 1
      // },
      visible: true,
      //fixedHeader: true,
      "order": [[0, "asc"]],  
      "processing": true,
      "serverSide": true,
      "bSort" : true,
      "Responsive":false,
      ajax: {
        type: "POST",
        async:false,
        data: { 
          'product_id': product_id,
          'product_type': product_type,
          // 'account_id': this.props.queryFilter.type,
          'keyword': this.props.queryFilter.searchkey,
          'sort': this.sort,
          'limit': 50,
          'count': true,
          'col_date': tableHeadData,
          'start_date': startdate,
          'end_date': enddate
        },
        beforeSend: function () {                     
           $("#progress-filter-loading").addClass("show");
        },
        //headers:{'x-access-token': token},
        // url: apiUrl+'get',
        url: admin_url + 'report/enquiry_json',
        "dataSrc": function (response) {
          this.setState({enquiry_json:response}, () => {
          })
          // }.bind(this))
          __sort = (typeof response.sort != 'undefined' && response.sort != '')?response.sort:__sort ;  
          $("#progress-filter-loading").removeClass("show");
          var rowdata = [];
          $.each(response.result, function (key, value) {
              var columns = [];
              var coldata = [];
              var i = 0;
              $.each(tableHeadData, function (headkey, headvalue) { 
                var filteredArray = [];
                var id = (typeof value[headvalue['id']] != 'undefined')?value[headvalue['id']]:'' ;  
                var type = (typeof value['product_type'] != 'undefined')?value['product_type']:'' ;  
                var col = (typeof value[headvalue['id']] != 'undefined')?value[headvalue['id']]:'-' ;  
                if(headvalue['id'] == "createdAt") {
                    let date = new Date(value[headvalue['id']]);
                    let timeZone = (window.inputTimezone == undefined) ? serverTimeZone : window.inputTimezone;
                    let new_date = date.toLocaleString("en-US", {timeZone: timeZone});
                    col = window.formatAMPM(window.changeDatesFormat(new_date));
                 }
                if(headvalue['id'] == "product_id") {
                  var productname = (typeof value['product_name'] != 'undefined')?value['product_name']:'-' ; 
                  
                  filteredArray = product_list.filter(function(item){
                    return item.id == id && item.type == type;
                  });
                  col = '-';
                  if(typeof filteredArray != 'undefined' && filteredArray.length > 0 ) {
                    col = (typeof filteredArray[0]['title'] != 'undefined' && filteredArray[0]['title'] != '')?filteredArray[0]['title']:productname;
                  }
                  else {
                    col = productname;
                  }
                }  
                if(headvalue['id'] == "delete") {
                 // col = `<a onClick="deleteEnquiry('`+value['_id']+`')">Delete</a>`;
                 col = `<span class="remove-enquiry"><a class="remove-enquiry" onClick="window.deleteEnquiry('`+value['_id']+`',this)"><span class="remove_access_text"> <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 612 612" style="enable-background:new 0 0 612 612;" width="12px" height="12px" xml:space="preserve"> <g> <g> <path d="M493.8,170.8H118.2c-11.4,0-20.6,9.2-20.6,20.6v321.5c0,54.6,44.5,99.1,99.1,99.1h218.6c54.6,0,99.1-44.5,99.1-99.1V191.4 C514.4,180,505.2,170.8,493.8,170.8z M256.5,488c0,14-11.3,25.3-25.3,25.3c-14,0-25.3-11.3-25.3-25.3V294.8 c0-14,11.3-25.3,25.3-25.3c14,0,25.3,11.3,25.3,25.3V488z M406,488c0,14-11.3,25.3-25.3,25.3c-14,0-25.3-11.3-25.3-25.3V294.8 c0-14,11.3-25.3,25.3-25.3c14,0,25.3,11.3,25.3,25.3V488z"></path> <path d="M473.2,32h-89.7v-7.8c0-13.4-10.9-24.2-24.2-24.2H252.7c-13.4,0-24.2,10.9-24.2,24.2V32h-89.7C104.5,32,76.5,60,76.5,94.3 v39.9c0,7.1,5.8,12.9,12.9,12.9h433.1c7.1,0,12.9-5.8,12.9-12.9V94.3C535.5,60,507.5,32,473.2,32z"></path> </g> </g> </svg> Delete </span></a></span>`;
                }     
                coldata[i] = '<span>'+col+'</span>';
                i++;
              });
              rowdata.push(columns.concat(coldata)); 
          });
          
          return rowdata;
        }.bind(this),
      },
      "language": {
        "emptyTable": "no data" 
      },
      "drawCallback": function (settings) {        
        $(".dataTables_scrollBody").css("overflow", "initial");
        $(".dataTables_scrollHead").css("overflow", "initial");
        // $("#bc-datatable").DataTable().columns.adjust(); 
      },
    });
    return false;
    }
    // return false;
  }
  
  componentDidUpdate(prevProps, newProps) {  
    // alert(__filter_applied+'-123654')
  //  console.log("prevProps", prevProps.queryFilter, newProps);
  //  console.log("this.props",this.props.filters);
    // $("#bc-datatable").DataTable().state.clear();
    // if (this.props.queryFilter.state_change == true) {
    //   $("#bc-datatable").DataTable().state.clear();
    // }
    // if ((this.props.queryFilter.searchkey !== prevProps.queryFilter.searchkey) || (this.props.queryFilter.startdate !== prevProps.queryFilter.startdate) || (this.props.queryFilter.enddate !== prevProps.queryFilter.enddate) || (this.props.queryFilter.product_type !== prevProps.queryFilter.product_type) || (this.props.queryFilter.product_id !== prevProps.queryFilter.product_id)) {
      // $('#bc-datatable').DataTable().destroy();
      if(__filter_applied === true)
      {
        // console.log(btoa(prevProps.queryFilter), btoa(this.state.filters), this.state.enquiry_json)
        // console.log(prevProps.queryFilter.enddate !== false , prevProps.queryFilter.old_product_type !== false , prevProps.queryFilter.product_id !== false , prevProps.queryFilter.product_name !== false , prevProps.queryFilter.product_type !== false , prevProps.queryFilter.searchkey !== false , prevProps.queryFilter.startdate  !== false)
        // this.setState({filters : prevProps.queryFilter}, () => {
          this.overallreportrender(); // enquiry_json:false, 
        // })
      }
  //  }
   
  }
  componentWillUnmount() {
  }
  render() {
      return (
        <div className="bc-datatable-holder">
            <table id="bc-datatable" className="display" style={{"width":"100%"}}  ref="main">
              { this.state.renderData ? <thead>{this.renderTableHeader()}</thead> : <thead><tr><td></td></tr></thead> }
            </table>
        </div>)
  }
}
export default WithSystem(Tbl);
